<template>
    <div>
        <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i> Récupération des données en cours</span>
          <span v-if="!loading && this.chart.datasets.length == 0" class="ix-text-secondary ix-text-small">Nous ne trouvons pas de données à vous afficher</span>

        <div v-if="!loading && this.chart.datasets.length > 0">
            <custom-chart type="bar" :datasets="chart.datasets" :labels="chart.labels" :options="chart.options"></custom-chart>
        </div>

         <div v-if="!loading" class="row">

            <div class="col-sm-12 col-md-4 mt-2">
                <div class="ix-count-box">
                    <h2 class="ix-count-box-title">Total crédit</h2>
                    <span class="ix-count-box-value">{{ currency(total_credits) }}</span>
                </div>
            </div>

            <div class="col-sm-12 col-md-4 mt-2">
                <div class="ix-count-box">
                    <h2 class="ix-count-box-title">Total débit</h2>
                    <span class="ix-count-box-value">- {{ currency(total_debits) }}</span>
                </div>
            </div>
               <div class="col-sm-12 col-md-4 mt-2">
                <div class="ix-count-box">
                    <h2 class="ix-count-box-title">Total crédit - débit</h2>
                    <span class="ix-count-box-value">{{ currency(total_credits - total_debits) }}</span>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

import CustomChart from '../CustomChart.vue';

export default {
    props: {
        route: String,
    },
    components: {
        CustomChart,
    },
    data() {
         return {
                loading: true,
                stats : null,
                total_credits: null,
                total_debits: null,

                chart: {
                    options: {
                        scales: {
                            y: {
                                ticks: {
                                    callback: (value, index, ticks) => {
                                        return this.currency(value);
                                    }
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                display: true,
                            },
                            tooltip: {
                                callbacks: {
                                    label: (context) => {
                                        let label = context.dataset.label || '';

                                        if (label) {
                                            label += ': ';
                                        }
                                        if (context.parsed.y !== null) {
                                            label += this.currency(context.parsed.y)
                                        }
                                        return label;
                                    }
                                }
                            }
                        }
                    },
                    labels: [],
                    datasets: []
                }
            };
    },
     methods: {
        getData : async function(){
                fetch(this.route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    this.chart.labels = data.labels
                    data.datasets.forEach(dataset => {
                        this.chart.datasets.push(dataset)
                    })
                    
                    this.total_credits = data.total_credits;
                    this.total_debits = data.total_debits;

                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            },
    },
    async mounted(){
        await this.getData();
    }
}
</script>